import { WidgetType } from 'domain/entity/widget';
import ImageData from 'domain/entity/widgets/ImageData';
import TextData from 'domain/entity/widgets/TextData';

export type WidgetDataTypes = WidgetData | TextData | ImageData;

type WidgetData = {
    type: WidgetType;
    dataAvailability: WidgetDataAvailability;
    description: WidgetDescription;
};

export enum PeriodType {
    TEXT = 'TEXT',
    INTERVAL = 'INTERVAL',
}

export enum DataAvailabilityKey {
    MAIN = 'MAIN',
    COMPARISON = 'COMPARISON',
}
export type Period = {
    type: PeriodType;
    text: string | null;
    from: Date | null;
    to: Date | null;
};
export type RawAvailability = {
    available: number;
    expected: number;
    weight: number;
    name: string;
    key: string;
};
export class WidgetDataAvailability {
    constructor(readonly rawAvailabilities: RawAvailability[], readonly enabled: boolean) {}
}

export class WidgetDescription {
    constructor(public title: string, public period: Period) {}
}

export enum ColorType {
    BY_DEFAULT = 'BY_DEFAULT',
    PRIMARY = 'PRIMARY',
    BACKGROUND = 'BACKGROUND',
}

export type Color = {
    type: ColorType;
    byDefault: string;
};

export type Icon = {
    key: string;
};

export default WidgetData;
